function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M112 112H0v112h56v28h84v-84h-28v-56zM372 112h70L386 0l-35 70-7-14-42 84h84l-14-28zM262.743 317.33C271.609 307.423 277 294.341 277 280c0-30.928-25.072-56-56-56s-56 25.072-56 56c0 14.341 5.391 27.423 14.257 37.33A42.385 42.385 0 0 0 179 322c0 23.196 18.804 42 42 42s42-18.804 42-42c0-1.578-.087-3.136-.257-4.67z",
  fill: "#020715"
});

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 221,
  cy: 322,
  r: 42,
  fill: "url(#image_svg__paint0_linear)",
  opacity: 0.4
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 221,
  cy: 322,
  r: 33.5,
  stroke: "#77BDFF",
  strokeDasharray: "3 3",
  opacity: 0.4
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M344 56l42 84h-84l42-84z",
  fill: "url(#image_svg__paint1_linear)",
  opacity: 0.4
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M342.038 70.923l1.308-2.615.447.223.207-.413.207.413.447-.223 1.308 2.615-.448.224 1.308 2.615.447-.224 1.308 2.616-.447.224 1.307 2.615.448-.224 1.307 2.616-.447.223 1.308 2.616.447-.224 1.308 2.615-.448.224 1.308 2.615.447-.223 1.308 2.615-.447.224 1.308 2.615.447-.224 1.307 2.616-.447.224 1.308 2.615.447-.224 1.308 2.616-.447.223 1.307 2.616.448-.224 1.307 2.615-.447.224 1.308 2.615.447-.223 1.308 2.615-.448.224 1.308 2.615.447-.223L369.5 118l-.447.224 1.307 2.615.448-.224 1.307 2.616-.447.223 1.308 2.616.447-.224 1.308 2.616-.447.223 1.307 2.616.447-.224 1.308 2.615-.447.224.292.584h-.736v.5h-3.091v-.5h-3.091v.5h-3.091v-.5h-3.091v.5H361v-.5h-3.091v.5h-3.091v-.5h-3.091v.5h-3.091v-.5h-3.091v.5h-3.09v-.5h-3.091v.5h-3.091v-.5h-3.091v.5h-3.091v-.5H327v.5h-3.091v-.5h-3.091v.5h-3.091v-.5h-3.091v.5h-3.091v-.5h-.736l.292-.584-.447-.224 1.308-2.615.447.224 1.307-2.616-.447-.223 1.308-2.616.447.224 1.308-2.616-.447-.223 1.307-2.616.448.224 1.307-2.615-.447-.224 1.308-2.615.447.223 1.308-2.615-.448-.224 1.308-2.615.447.223 1.308-2.615-.447-.224 1.307-2.615.448.224 1.307-2.616-.447-.223 1.308-2.616.447.224 1.308-2.615-.447-.224 1.307-2.615.447.223 1.308-2.615-.447-.224 1.308-2.615.447.223 1.308-2.615-.448-.224L335.5 84l.447.224 1.308-2.616-.447-.223 1.307-2.616.448.224 1.307-2.615-.447-.224 1.308-2.615.447.223 1.308-2.615-.448-.224z",
  stroke: "#77BDFF",
  strokeDasharray: "3 3",
  opacity: 0.4
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#image_svg__paint2_linear)",
  d: "M56 168h84v84H56z",
  opacity: 0.4
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#77BDFF",
  strokeDasharray: "3 3",
  d: "M64.5 176.5h67v67h-67z",
  opacity: 0.4
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M386 0l56 112H330L386 0z",
  fill: "url(#image_svg__paint3_linear)",
  opacity: 0.9
});

var _ref9 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 221,
  cy: 280,
  r: 56,
  fill: "url(#image_svg__paint4_linear)",
  opacity: 0.9
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#image_svg__paint5_linear)",
  d: "M0 112h112v112H0z",
  opacity: 0.9
});

var _ref11 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "image_svg__paint0_linear",
  x1: 179,
  y1: 280,
  x2: 263,
  y2: 364,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "image_svg__paint1_linear",
  x1: 302,
  y1: 56,
  x2: 386,
  y2: 140,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "image_svg__paint2_linear",
  x1: 56,
  y1: 168,
  x2: 140,
  y2: 252,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "image_svg__paint3_linear",
  x1: 330,
  y1: 0,
  x2: 442,
  y2: 112,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "image_svg__paint4_linear",
  x1: 165,
  y1: 224,
  x2: 277,
  y2: 336,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})), React.createElement("linearGradient", {
  id: "image_svg__paint5_linear",
  x1: 0,
  y1: 112,
  x2: 112,
  y2: 224,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.199,
  stopColor: "#77BDFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0E4EFF"
})));

var SvgImage = function SvgImage(props) {
  return React.createElement("svg", _extends({
    width: 442,
    height: 364,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

export default "data:image/svg+xml;base64,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";
export { SvgImage as ReactComponent };